import { RequestParameters } from "@iventis/mapbox-gl";

export function mapRequestInterceptor(url: string): RequestParameters {
    let urlObject: URL;
    // If the request is for a api.os.uk map tile, add the required srs parameter
    if (!url.startsWith("/")) {
        urlObject = new URL(url);
        if (urlObject.hostname === "api.os.uk") urlObject.searchParams.append("srs", "3857");
    }
    if (urlObject) {
        return { url: urlObject.toString() };
    }
    return { url };
}
